module.exports = __webpack_public_path__ + "static/media/boat.30d6dc27.png";